import React from 'react';
import { CircleImage, CircleImageContent, Badge } from 'react-myoneui';

const LearnerNameTemplate = ({ value, data, tableManager }) => {
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate ps-2' + (additionalProps.className || '')).trim();

  return (
    <div
      {...additionalProps}
      className={classNames}
      title={value}
    >
      <div className="d-flex gap-2 align-items-center">
        <CircleImage className="circle-wrap circle-wrap-md">
          <CircleImageContent svgImage="one" />
        </CircleImage>
        <span>{value}</span>
        {data.isNew && <Badge className="badge blue badge-round">New</Badge>}
      </div>
    </div>
  );
};

export default LearnerNameTemplate;
